<template>
	<input 
		type="text" 
		class="form-control" 
		:id="id" 
		:data-key="key"
		:disabled="disabled"
		v-bind:value="value" 
		@input="onInput"
	>
</template>

<script>
import Awesomeplete from "awesomplete";
import "awesomplete/awesomplete.css";

export default {
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		id: {
			type: String,
			default: null,
		},
		value: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		onSelect: {
			type: Function,
			required: false,
		},
	},
	computed: {
		parsedList() {
			return this.list.map( item => ({
				label: item.name,
				value: item.id,
			}) );
		}
	},
	data() {
		return {
			element: null,
			key: null,
		}
	},
	methods: {
		onInput(e) {
			this.$emit('input', e.target.value);
		}
	},
	beforeMount() {
		this.key = new Date().getUTCMilliseconds();
	},
	mounted() {
		let selector = `[data-key="${this.key}"]`;

		this.element = new Awesomeplete(selector, {
			list: this.parsedList,
			replace: function(suggestion) {
				this.input.value = suggestion.label;
			}
		});

		$(document).on('awesomplete-selectcomplete', selector, e => {
			if (typeof this.onSelect === 'function') {
				this.onSelect(e.originalEvent.text);
			}
		});
	}
}
</script>
